<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="fechar">
    <q-card class="neg-escopo neg-modal">
      <q-card-section class="neg-modal__titulo">
        Reatribuir carteira
        <div class="neg-sub">
          Move de uma vez as oportunidades abertas de um Operador para outro
        </div>
      </q-card-section>

      <q-card-section class="neg-modal__corpo">
        <q-select
          dense
          emit-value
          map-options
          label="Operador de origem"
          option-value="id"
          option-label="label"
          :options="negociosFuncionarios"
          :model-value="origemId"
          @update:model-value="selecionarOrigem"
        />

        <q-select
          dense
          emit-value
          map-options
          label="Operador de destino"
          option-value="id"
          option-label="label"
          :options="negociosFuncionarios"
          :model-value="destinoId"
          @update:model-value="selecionarDestino"
        />

        <div v-if="carregandoPrevia" class="neg-sub">Calculando a carteira…</div>

        <template v-else-if="previa">
          <div v-if="!previa.success" class="neg-aviso">
            {{ previa.message }}
          </div>

          <template v-else>
            <p>
              <b>{{ previa.quantidade }}</b>
              {{ previa.quantidade === 1 ? "oportunidade será movida" : "oportunidades serão movidas" }}
              de <b>{{ previa.origem.nome }}</b> para <b>{{ previa.destino.nome }}</b>.
            </p>

            <div
              v-for="oportunidade in previa.oportunidades"
              :key="oportunidade.id"
              class="neg-linha"
            >
              <span>
                <b>{{ oportunidade.codigo }}</b>
                <div class="neg-sub">
                  {{ oportunidade.cliente }} · {{ oportunidade.linha }} · {{ oportunidade.etapa }}
                </div>
              </span>
              <span>{{ formatarMoeda(valorDaLinhaDaPrevia(oportunidade)) }}</span>
            </div>
          </template>
        </template>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps label="Cancelar" @click="fechar(false)" />
        <q-btn
          unelevated
          no-caps
          color="primary"
          label="Confirmar transferência"
          :disable="!podeConfirmar"
          :loading="transferindo"
          @click="confirmar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-modal-reatribuicao",

  emits: ["update:modelValue", "transferiu"],
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      origemId: null,
      destinoId: null,
      previa: null,
      carregandoPrevia: false,
      transferindo: false
    };
  },
  computed: {
    ...mapGetters(["negociosFuncionarios"]),
    podeConfirmar() {
      return Boolean(this.previa && this.previa.success && this.previa.quantidade > 0);
    }
  },
  watch: {
    modelValue(aberto) {
      if (!aberto) {
        return;
      }

      this.origemId = null;
      this.destinoId = null;
      this.previa = null;
    }
  },
  methods: {
    valorDaLinhaDaPrevia(oportunidade) {
      return oportunidade.valor_contratado === null || oportunidade.valor_contratado === undefined
        ? oportunidade.valor_solicitado
        : oportunidade.valor_contratado;
    },
    selecionarOrigem(id) {
      this.origemId = id;
      this.atualizarPrevia();
    },
    selecionarDestino(id) {
      this.destinoId = id;
      this.atualizarPrevia();
    },
    atualizarPrevia() {
      this.previa = null;

      if (!this.origemId || !this.destinoId) {
        return;
      }

      this.carregandoPrevia = true;

      this.$store
        .dispatch("carregarNegociosPreviaCarteira", {
          origemId: this.origemId,
          destinoId: this.destinoId
        })
        .then(resposta => {
          this.carregandoPrevia = false;
          this.previa = resposta;
        });
    },
    confirmar() {
      this.transferindo = true;

      this.$store
        .dispatch("transferirNegociosCarteira", {
          origemId: this.origemId,
          destinoId: this.destinoId
        })
        .then(resposta => {
          this.transferindo = false;

          this.avisar(resposta.message, resposta.success ? "green" : "orange");

          if (resposta.success) {
            this.$emit("transferiu");
            this.fechar(false);
          }
        });
    },
    fechar(aberto) {
      this.$emit("update:modelValue", aberto === true);
    }
  }
};
</script>
